import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentFail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const errorCode = searchParams.get("errorCode") || "UNKNOWN";
  const errorMessage =
    searchParams.get("error") || "Ödeme işlemi başarısız oldu.";
  const orderId = searchParams.get("orderId");

  useEffect(() => {
    // 10 saniye sonra ana sayfaya yönlendir
    const timer = setTimeout(() => {
      navigate("/");
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "100px auto",
        padding: "40px",
        background: "#fee",
        borderRadius: "20px",
        textAlign: "center",
      }}
    >
      <XCircle size={80} style={{ color: "#dc2626", margin: "0 auto 20px" }} />
      <h1 style={{ color: "#991b1b", marginBottom: "15px" }}>
        Ödeme Başarısız
      </h1>
      <p style={{ color: "#7f1d1d", fontSize: "16px", marginBottom: "10px" }}>
        {errorMessage}
      </p>
      <p style={{ color: "#991b1b", fontSize: "14px", marginBottom: "30px" }}>
        Hata Kodu: {errorCode}
      </p>

      {orderId && (
        <div
          style={{
            background: "white",
            padding: "15px",
            borderRadius: "10px",
            marginBottom: "25px",
            fontSize: "12px",
            color: "#64748b",
          }}
        >
          İşlem No: {orderId}
        </div>
      )}

      <div
        style={{
          display: "flex",
          gap: "15px",
          justifyContent: "center",
          marginBottom: "20px",
        }}
      >
        <button
          onClick={() => navigate("/")}
          style={{
            padding: "12px 30px",
            background: "#dc2626",
            color: "white",
            border: "none",
            borderRadius: "10px",
            fontSize: "16px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Ana Sayfa
        </button>
        <button
          onClick={() => navigate("/register")}
          style={{
            padding: "12px 30px",
            background: "white",
            color: "#dc2626",
            border: "2px solid #dc2626",
            borderRadius: "10px",
            fontSize: "16px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Tekrar Dene
        </button>
      </div>

      <p style={{ color: "#991b1b", fontSize: "14px" }}>
        10 saniye sonra ana sayfaya yönlendirileceksiniz...
      </p>
    </div>
  );
};

export default PaymentFail;
